/**
 * A pending bank transfer carries the provisional period `create_signup`
 * writes at signup. `BankTransferService.activate` resets that period from the
 * activation date, so while the status is `pending` the dates are a
 * placeholder rather than an expiry, and every screen that shows them says so.
 */
export const isProvisionalPeriod = (status?: string | null) =>
  status === 'pending'
